import { showPledgePayTable } from './pledge-pay-modal-core';
import { configurePledgePay } from './pledge-pay-config';
import { setPledgePayMemberContext } from './pledge-pay-member-context';
import { requirePayPledges } from './pay-pledge-map';
import {
    applyDeletedSchedulePlan,
    consumeDeletedSchedulePlanForKeys,
    pledgeKeysForPlan,
    stageDeletedSchedulePlan,
} from './pledge-pay-deleted-schedule';
import { updatePledgePayNowButtonEnabledState } from './pledge-pay-amount';
import { submitPledgeBillPayment } from './pledge-pay-bill-submit';
import { initPledgeExpressPay } from './pledge-pay-express';
import { initPledgeSwipePay } from './pledge-pay-swipe';
import {
    mgrPledgeModalSyncSummaryVisibility,
    pledgePaymentBodySyncOpenPaymentSummary,
    refreshManagerPledgeModalOpenPaymentSection,
} from './pledge-pay-balance';
import { mgrPledgeModalSyncPaymentMethodPanels } from './pledge-pay-method';

function parseMemberPledgePayPageConfig() {
    const el = document.getElementById('member-pledge-pay-page-config');
    if (!el?.textContent) {
        throw new Error('parseMemberPledgePayPageConfig: #member-pledge-pay-page-config is required');
    }
    try {
        return JSON.parse(el.textContent);
    } catch (e) {
        throw new Error('parseMemberPledgePayPageConfig: invalid JSON');
    }
}

function bootstrapMemberPledgePayPageConfig($body) {
    const cfg = parseMemberPledgePayPageConfig();
    configurePledgePay(cfg);
    const userId = String($body.find('#payment_user_id').val() || '').trim();
    if (!userId) {
        throw new Error('bootstrapMemberPledgePayPageConfig: #payment_user_id is required');
    }
    setPledgePayMemberContext(userId, {
        hasSavedCards: !!cfg.userHasSavedCards,
    });
    return cfg;
}

function openMemberPayPage(keys) {
    const deletedPlan = consumeDeletedSchedulePlanForKeys(keys);
    const payKeys = deletedPlan ? pledgeKeysForPlan(deletedPlan) : keys;
    const pledges = requirePayPledges(payKeys.length ? payKeys : keys);
    if (!pledges) {
        return;
    }
    const $body = $('#pledge_pay_body');
    if (deletedPlan) {
        stageDeletedSchedulePlan($body, deletedPlan);
    }
    const cfg = bootstrapMemberPledgePayPageConfig($body);
    const result = showPledgePayTable($body, pledges, 'pay', {
        surface: 'manager_page',
        payType: 'pay',
        isRecurringMode: false,
    });
    if (result) {
        $body.find('#total_amount').val(result.totalAmount);
    }

    mgrPledgeModalSyncSummaryVisibility($body);
    pledgePaymentBodySyncOpenPaymentSummary($body, false);
    $body.find('input[name="mgr_pledge_payment_method_pref"]').prop('checked', false);
    refreshManagerPledgeModalOpenPaymentSection($body).then(() => {
        applyDeletedSchedulePlan($body);
        mgrPledgeModalSyncPaymentMethodPanels($body);
        updatePledgePayNowButtonEnabledState($body);
    });
    initPledgeExpressPay($body, pledges, cfg);
    initPledgeSwipePay($body, pledges, cfg);
}

function openPledgePayPage() {
    const $pledgePayBody = $('#pledge_pay_body');
    const cfg = bootstrapMemberPledgePayPageConfig($pledgePayBody);
    submitPledgeBillPayment($pledgePayBody, cfg);
    return false;
}

let memberPledgePayHandlersBound = false;

function bindPledgePayMemberDocumentHandlers() {
    if (memberPledgePayHandlersBound) {
        throw new Error('bindPledgePayMemberDocumentHandlers: already bound');
    }
    memberPledgePayHandlersBound = true;

    document.addEventListener('click', (e) => {
        if (e.target.closest('[data-action="open-pledge-pay-page"]')) {
            openPledgePayPage();
        }
    });
}

export {
    bindPledgePayMemberDocumentHandlers,
    openMemberPayPage,
    openPledgePayPage,
    bootstrapMemberPledgePayPageConfig,
    parseMemberPledgePayPageConfig,
};
